import {types} from 'mobx-state-tree';

export type ChatUserViews = {
  name: string;
};

const ChatUserModel = types
  .model('ChatUser', {
    id: types.identifierNumber,
    firstName: types.string,
    lastName: types.maybe(types.string),
    avatar: types.maybe(types.string),
    role: types.maybe(
      types.model({
        id: types.number,
        code: types.string,
        name: types.string
      })
    )
  })
  .views<ChatUserViews>(self => ({
    get name() {
      const {firstName, lastName} = self;
      return lastName ? `${firstName} ${lastName}` : firstName;
    }
  }));

export type ChatUserModelType = typeof ChatUserModel.Type;

export default ChatUserModel;



// WEBPACK FOOTER //
// ./src/models/ChatUserModel/ChatUserModel.ts